export const INFORMATION_BAR_COUNTER_DATA_TEST_ID = 'information-bar-counter'
export const INFORMATION_BAR_MOBILE_DATA_TEST_ID = 'information-bar-mobile'
